import React, { useState } from 'react';
import api from '../../services/api';
import './PublicUpload.css';

const PublicUpload = ({ onUploadSuccess }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [caption, setCaption] = useState('');
    const [uploading, setUploading] = useState(false);
    const [dragActive, setDragActive] = useState(false);

    const toggleModal = () => setIsOpen(!isOpen);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setFile(e.dataTransfer.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) return;

        const formData = new FormData();
        formData.append('image', file);
        formData.append('caption', caption);

        try {
            setUploading(true);
            await api.post('/gallery', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Reset form and close
            setFile(null);
            setCaption('');
            setIsOpen(false);
            if (onUploadSuccess) onUploadSuccess();
        } catch (error) {
            console.error('Error uploading photo:', error);
            alert('Failed to upload image. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <button className="fab-add-photo" onClick={toggleModal} title="Add Photo">
                <span className="plus-icon">+</span>
                <span className="fab-text">Add Photo</span>
            </button>

            {isOpen && (
                <div className="public-upload-overlay" onClick={toggleModal}>
                    <div className="public-upload-modal" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={toggleModal}>×</button>
                        <h2 className="upload-title">SHARE YOUR MOMENTS</h2>
                        <form onSubmit={handleSubmit} className="upload-form-card">
                            <div 
                                className={`file-drop-area ${dragActive ? 'drag-active' : ''} ${file ? 'has-file' : ''}`}
                                onDragEnter={handleDrag}
                                onDragLeave={handleDrag}
                                onDragOver={handleDrag}
                                onDrop={handleDrop}
                            >
                                <input 
                                    type="file" 
                                    id="file-upload" 
                                    className="file-input" 
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                                <label htmlFor="file-upload" className="file-label">
                                    {file ? (
                                        <div className="file-preview-info">
                                            <span className="file-name">{file.name}</span>
                                            <span className="change-btn">Change Image</span>
                                        </div>
                                    ) : (
                                        <div className="upload-prompt">
                                            <span className="upload-icon">📸</span>
                                            <span className="upload-text">Select Image</span>
                                            <span className="upload-subtext">Click to choose a photo from your gallery!</span>
                                        </div>
                                    )}
                                </label>
                            </div>

                            <div className="caption-input-group">
                                <input 
                                    type="text" 
                                    value={caption}
                                    onChange={(e) => setCaption(e.target.value)}
                                    placeholder="Add a fiery caption..."
                                    className="public-caption-input"
                                />
                            </div>

                            <button 
                                type="submit" 
                                className={`public-upload-btn ${!file || uploading ? 'disabled' : ''}`}
                                disabled={!file || uploading}
                            >
                                {uploading ? (
                                    <div className="loader-container">
                                        <span className="mini-loader"></span>
                                        Uploading...
                                    </div>
                                ) : 'UPLOAD TO GALLERY'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default PublicUpload;
